<form [formGroup]="loginForm">
  <ion-grid>
    <ion-row class="ion-align-items-center ion-justify-content-start">
      <!-- form -->
      <ion-col>
        <ion-row class="ion-align-items-center ion-justify-content-start" max-width-form>
          <ion-col size="12">
            <ion-row>
              <ion-col size="12">
                <ion-label type="email" position="stacked">{{"LOGIN.EMAIL" | translate}}</ion-label>
                <ion-input
                  formControlName="username"
                  placeholder="{{ 'LOGIN.ENTER_THE_LOGIN_EMAIL' | translate }}"
                  (ionBlur)="usernameOnBlur()"
                ></ion-input>
              </ion-col>
            </ion-row>
            <!-- username required -->
            <ion-note
              margin-top
              color="danger"
              class="ion-text-center"
              *ngIf="username.dirty && username.errors?.required"
            >
              {{'LOGIN.ENTER_YOUR_EMAIL' | translate}}
            </ion-note>

            <!-- username invalid -->
            <ion-note
              color="danger"
              class="ion-text-center ion-margin-top"
              *ngIf="username.dirty && username.errors?.email && !username.errors?.required"
            >
              {{'LOGIN.INVALID_EMAIL' | translate}}
            </ion-note>

            <!-- email max length -->
            <ion-note
              color="danger"
              class="text-center margin-top"
              *ngIf="
              username.dirty && !username.errors?.email && !username.errors?.required && username.errors?.maxlength
              "
            >
              {{"LOGIN.THE_EMAIL_MUST_CONTAIN_AT_MOST" | translate}} {{
              username.errors.maxlength.requiredLength }} {{"LOGIN.CHARACTERS" | translate}}
            </ion-note>
          </ion-col>

          <ion-col size="12">
            <ion-row>
              <ion-col size="12">
                <ion-label position="stacked">{{'LOGIN.PASSWORD' | translate}}</ion-label>
                <ion-input
                  class="eye"
                  [type]="showPass ? 'text' : 'password'"
                  formControlName="password"
                  placeholder="{{ 'LOGIN.ENTER_YOUR_PASSWORD' | translate }}"
                  (keyup.enter)="login(loginForm)"
                >
                </ion-input>
                <ion-button class="eye" fill="clear" (click)="showPass = !showPass">
                  <ion-icon slot="icon-only" [name]="showPass ? 'eye-off' : 'eye'"></ion-icon>
                </ion-button>
              </ion-col>
            </ion-row>

            <!-- password required -->
            <ion-note
              color="danger"
              class="ion-text-center ion-margin-top"
              *ngIf="password.dirty && password.errors?.required"
            >
              {{"LOGIN.ENTER_YOUR_PASSWORD" | translate}}
            </ion-note>

            <!-- password invalid -->
            <ion-note
              color="danger"
              class="ion-text-center ion-margin-top"
              *ngIf="password.dirty && password.errors?.minlength && !password.errors?.required"
            >
              {{"LOGIN.PASSWORD_MUST_CONTAIN" | translate}} {{ password.errors.minlength.requiredLength }}
              {{"LOGIN.CHARACTERS_OR_MORE" | translate}}
            </ion-note>

            <!-- password invalid -->
            <ion-note
              color="danger"
              class="ion-text-center ion-margin-top"
              *ngIf="password.dirty && password.errors?.maxlength && !password.errors?.minlength && !password.errors?.required"
            >
              {{"LOGIN.THE_PASSWORD_MUST_CONTAIN_AT_MOST" | translate}} {{
              password.errors.maxlength.requiredLength }} {{"LOGIN.CHARACTERS" | translate}}
            </ion-note>

            <!-- incorrect credentials -->
            <ion-note
              class="ion-text-center ion-margin-top"
              color="danger"
              *ngIf="showNoteWithoutCredentials"
            >
              {{"LOGIN.UNABLE_TO_LOGIN" | translate}}
            </ion-note>

            <!-- without credentials -->
            <ion-note
              class="ion-text-center ion-margin-top"
              color="danger"
              *ngIf="showNoteWithCredentials && !showNoteWithoutCredentials"
            >
              {{"LOGIN.CHECK_THE_FIELDS" | translate}}
            </ion-note>
          </ion-col>

          <ion-col size="7">
            <ion-item lines="none" detail="false" class="ion-text-start keep-session">
              <ion-label>{{"LOGIN.KEEP_CONNECTED" | translate}}</ion-label>
              <ion-checkbox formControlName="keepSession" color="primary-dark-checkbox" checked slot="end">
              </ion-checkbox>
            </ion-item>
          </ion-col>

          <ion-col sizeLg="5" class="ion-text-end ion-padding-end">
            <label class="text-primary recovery-pass" (click)="goToRecoveryPassword()">
              {{"LOGIN.FORGOT_PASSWORD" | translate}}
            </label>
          </ion-col>

          <ion-col size="12">
            <ion-button expand="block" color="buttonPrimary" (click)="login(loginForm)">
              {{"LOGIN.TO_ENTER" | translate}}
            </ion-button>
          </ion-col>

          <ion-col size="12">
            <ion-button expand="block" color="buttonPrimary" (click)="goToNewUser()">
              {{"LOGIN.CREATE_AN_ACCOUNT" | translate}}
            </ion-button>
          </ion-col>

          <ion-col class="ion-text-center">
            <ion-label class="survey-tutorial" (click)="accessTraining('makeSurvey')">
                {{'TRAINING.HOW_TO_MAKE_SURVEY' | translate}}
            </ion-label>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </ion-grid>
</form>

<ion-label class="ion-padding-bottom ion-text-center" *ngIf="isMobile">
  {{"LOGIN.VERSION" | translate}} {{ appVersionNumber || '1.0.0' }}
</ion-label>
